// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"playerStats_dropdown__GmemO","donutChart":"playerStats_donutChart__3usSP","default":"playerStats_default__3sbrK"};